export const NAVIGATION_SHOW_MODAL = 'NAVIGATION_SHOW_MODAL'
export const NAVIGATION_HIDE_MODAL = 'NAVIGATION_HIDE_MODAL'
